import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ContactsService } from '../shared/services/contacts.service';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { SetTagsForSelectedAction } from '../contacts.actions';
import { NotificationService } from '../../shared/notification.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { getMassiveActionSelector } from '../contacts.reducer';

@Component({
  selector: 'cc-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {
  public selectedContacts: number[] = [];
  public excludedContacts: number[] = [];
  public name: string;
  public tag: string;
  public tagSetError: boolean;
  public visible = true;
  public selectable = true;
  public removable = true;
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public tagCtrl = new FormControl();
  public filteredTags: Observable<string[]>;
  public chosenTagList: string[] = [];
  public globalTagList: string[] = [];

  public isMassiveAction: boolean;
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    public contactsService: ContactsService,
    private store: Store<IState>,
    public notificationService: NotificationService
  ) {
    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) => (tag ? this._filter(tag) : this.globalTagList.slice()))
    );
  }

  ngOnInit() {
    this.contactsService.getFilterByTags().subscribe(tagList => {
      this.globalTagList = !!tagList && !!tagList.length ? tagList : [];
    });

    this.contactsService.onAddTagsToContacts.subscribe(params => {
      this.selectedContacts = params && params.includedToTag ? params.includedToTag : [];
      this.excludedContacts = params && params.excludedFromTag ? params.excludedFromTag : [];
    });

    this.store.select(getMassiveActionSelector).subscribe(isMassive => {
      this.isMassiveAction = isMassive;
    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.chosenTagList.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    this.tagCtrl.setValue(null);
  }

  remove(tag: string): void {
    const index = this.chosenTagList.indexOf(tag);

    if (index >= 0) {
      this.chosenTagList.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.chosenTagList && !this.chosenTagList.includes(event.option.viewValue)) {
      this.chosenTagList.push(event.option.viewValue);
      this.tagInput.nativeElement.value = '';
    } else {
      console.log(`tag ${event.option.viewValue} is on the list`);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.globalTagList.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
  }

  setTagsForContacts() {
    const selectList = document.querySelector('.mat-autocomplete-visible');
    const fullParams = {
      include: this.isMassiveAction ? [] : this.selectedContacts,
      exclude: this.isMassiveAction ? this.excludedContacts : [],
      tags: this.chosenTagList
    };

    if (this.selectedContacts && this.selectedContacts.length) {
      this.store.dispatch(new SetTagsForSelectedAction(fullParams));
      this.tagSetError = false;
      this.contactsService.toggleTagsEditor(false);
      this.chosenTagList = [];
    } else {
      this.tagSetError = true;
    }
    if (selectList) {
      selectList.classList.remove('mat-autocomplete-visible');
    }
    this.contactsService.rowCollapse();
  }

  editorExit($event) {
    if (
      !$event.target.className.includes('mat-option-text') &&
      !$event.target.className.includes('tag-editor') &&
      !$event.target.className.includes('button-tag-wrapper') &&
      !$event.target.className.includes('tag-selector') &&
      !$event.target.className.includes('ng2-menu-item') &&
      !$event.target.className.includes('fa-tag') &&
      !$event.target.className.includes('ng2-dropdown-backdrop') &&
      $event.target.className !== 'ng-star-inserted'
    ) {
      this.contactsService.toggleTagsEditor(false);
    }
  }
}
